/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [异常列表-异常商品申请赔付↗](http://yapi.yishou.com/project/128/interface/api/33529) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/applyCompensate`
 * @更新时间 `2022-05-10 18:20:26`
 */
const applyCompensateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/applyCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { dbids: { type: "array", items: { type: "string" } } },
        required: ["dbids"],
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "applyCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [异常列表-异常商品申请赔付↗](http://yapi.yishou.com/project/128/interface/api/33529) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/applyCompensate`
 * @更新时间 `2022-05-10 18:20:26`
 */
export const applyCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(applyCompensateRequestConfig, requestData), ...args);
};
applyCompensate.requestConfig = applyCompensateRequestConfig;
/**
 * 接口 [入库日志-批量转入\/转出异常状态↗](http://yapi.yishou.com/project/128/interface/api/33538) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/editStockException?import=1`
 * @更新时间 `2022-05-10 18:15:24`
 */
const editStockExceptionImport_1RequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/editStockException?import=1",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbids", "markType", "is_pc", "exceptionSource", "file"],
        properties: {
            dbids: { type: "string" },
            markType: { type: "string", description: "下载模板，批量导入时需带上参数{1：标记异常，2：恢复正常}" },
            is_pc: { type: "string", description: "" },
            exceptionSource: { type: "string", description: "异常来源 (1:其他异常,4:改标异常)" },
            file: { type: "file", description: "", tsType: "FileData" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            errMsg: { type: "string", description: "错误描述" },
            file: { type: "string", description: "文件路径" },
        },
        required: ["file"],
    },
    requestFunctionName: "editStockExceptionImport_1",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [入库日志-批量转入\/转出异常状态↗](http://yapi.yishou.com/project/128/interface/api/33538) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/editStockException?import=1`
 * @更新时间 `2022-05-10 18:15:24`
 */
export const editStockExceptionImport_1 = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editStockExceptionImport_1RequestConfig, requestData), ...args);
};
editStockExceptionImport_1.requestConfig = editStockExceptionImport_1RequestConfig;
/**
 * 接口 [商品入库列表↗](http://yapi.yishou.com/project/128/interface/api/33541) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `GET /erp/StockInRecord/list`
 * @更新时间 `2022-05-10 16:53:44`
 */
const listRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["is_compensate"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_compensate"],
        properties: { is_compensate: { type: "string", description: "是否买赔商品" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            optionsPg: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsMs: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: ["number", "string"] }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsOrigin: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsWhere: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" }, count: { type: "number" } },
                    required: ["key", "label", "count"],
                },
            },
            optionsStatus: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsLevel: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsblp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionPurchaseDaBiaoMethod: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            exceptionSourceOp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsPiciType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsPgMember: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            owner_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            dg_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            option_dgm: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            dgm_refunder: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            signExceptionSourceOp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "标记异常来源",
            },
            optionIsCompensate: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "是否买赔",
            },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { is_compensate_msg: { type: "string", description: "买赔商品描述" } },
                    required: ["is_compensate_msg"],
                },
            },
        },
        required: ["optionIsCompensate", "list"],
    },
    requestFunctionName: "list",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商品入库列表↗](http://yapi.yishou.com/project/128/interface/api/33541) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `GET /erp/StockInRecord/list`
 * @更新时间 `2022-05-10 16:53:44`
 */
export const list = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listRequestConfig, requestData), ...args);
};
list.requestConfig = listRequestConfig;
/**
 * 接口 [异常列表-标记异常dbid列表↗](http://yapi.yishou.com/project/128/interface/api/33545) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/exceptionList`
 * @更新时间 `2022-05-10 11:28:45`
 */
const exceptionListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/exceptionList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        dbid: { type: "string" },
                        exception_dbid_source: { type: "string" },
                        goods_no: { type: "string" },
                        exception_admin_name: { type: "string" },
                        exception_time: { type: "string" },
                        stock_in_time: { type: "string" },
                        goods_no_co_si_val: { type: "string" },
                        goods_name: { type: "string" },
                        sku: { type: "string" },
                        supply_market_brand: { type: "string" },
                        cat_name: { type: "string" },
                        da_biao_record_type: { type: "string" },
                        stock_in_record_stock_source: { type: "string" },
                        storehouse_id: { type: "string" },
                        status: { type: "string" },
                        stock_in_record_origin: { type: "string" },
                        goods_img: { type: "array", items: { type: "string" } },
                        exception_status_msg: { type: "string", description: "商品异常状态" },
                    },
                    required: [
                        "dbid",
                        "exception_dbid_source",
                        "goods_no",
                        "exception_admin_name",
                        "exception_time",
                        "stock_in_time",
                        "goods_no_co_si_val",
                        "goods_name",
                        "sku",
                        "supply_market_brand",
                        "cat_name",
                        "da_biao_record_type",
                        "stock_in_record_stock_source",
                        "storehouse_id",
                        "status",
                        "stock_in_record_origin",
                        "goods_img",
                        "exception_status_msg",
                    ],
                },
            },
            total: { type: "number" },
            exception_source_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
            stock_in_stock_source_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
            stock_in_record_origin_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
        },
    },
    requestFunctionName: "exceptionList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [异常列表-标记异常dbid列表↗](http://yapi.yishou.com/project/128/interface/api/33545) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/exceptionList`
 * @更新时间 `2022-05-10 11:28:45`
 */
export const exceptionList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exceptionListRequestConfig, requestData), ...args);
};
exceptionList.requestConfig = exceptionListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/stockInRecord.js